import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import request from './request';
import getPrettyError from '../getPrettyError';

var useRequest = function useRequest(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      response = _React$useState2[0],
      setResponse = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      error = _React$useState4[0],
      setError = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var _React$useState7 = React.useState(null),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      reloadFlag = _React$useState8[0],
      setReloadFlag = _React$useState8[1];

  var onloadPromiseRef = React.useRef([]);
  var useMicroserviceBackend = options.useMicroserviceBackend;
  React.useEffect(function () {
    setLoading(true);
    request({
      url: url,
      useMicroserviceBackend: useMicroserviceBackend
    }).then(function (apps) {
      setResponse(apps);
      setLoading(false);
      onloadPromiseRef.current.map(function (_ref) {
        var resolve = _ref.resolve;
        return resolve();
      });
      onloadPromiseRef.current = [];
    }).catch(function (err) {
      setError(getPrettyError(err));
      setLoading(false);
      onloadPromiseRef.current.map(function (_ref2) {
        var reject = _ref2.reject;
        return reject();
      });
      onloadPromiseRef.current = [];
    });
  }, [url, useMicroserviceBackend, reloadFlag, onloadPromiseRef]);
  return {
    response: response,
    error: error,
    loading: loading,
    reload: function reload() {
      return new Promise(function (resolve, reject) {
        onloadPromiseRef.current.push({
          resolve: resolve,
          reject: reject
        });
        setReloadFlag(function (f) {
          return !f;
        });
      });
    }
  };
};

export default useRequest;